<template>
  <v-container class="d-flex flex-column ga-3">
    <v-row>
      <v-col>
        <UsageExample v-model="tab" :code="code" :tabs="tabs" width="150">
          <v-card elevation="4" class="ma-2">
            <v-card-title class="font-weight-bold">Regular</v-card-title>
            <v-card-text class="d-flex ga-3 flex-wrap">
              <HxBreadcrumbs id="breadcrumbs-id" regular :items="showItems" />
            </v-card-text>
          </v-card>
          <v-card elevation="4" class="ma-2">
            <v-card-title class="font-weight-bold">Compact</v-card-title>
            <v-card-text class="d-flex ga-3 flex-wrap">
              <HxBreadcrumbs id="breadcrumbs-id" compact :items="showItems" />
            </v-card-text>
          </v-card>
          <template #configuration>
            <div class="d-flex flex-column mt-16">
              <v-select v-model="selectedValue" :items="[1, 2, 3, 4, 5]" label="Items"></v-select>
              <HxCheckbox v-model="showLongTitle" label="Show long title" />
            </div>
          </template>
        </UsageExample>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixBreadcrumbs',
  components: { UsageExample },
  setup() {
    const code = `
<hx-breadcrumbs
  regular
  id="breadcrumbs-id"
  :items="[
    {
      text: 'Home',
      key: 'Home',
      to: '/',
      disabled: false
    }
  ]"
/>
<hx-breadcrumbs compact id="breadcrumbs-id" :items="items" />
    `;
    return { code };
  },
  data() {
    return {
      tab: 'Breadcrumbs Usage',
      tabs: ['Breadcrumbs Usage'],
      selectedValue: 5,
      showLongTitle: false,
      items: [
        {
          text: 'Home',
          key: 'Home',
          to: '/',
          disabled: false
        },
        {
          text: 'Student Duty of Care',
          key: 'Student Duty of Care',
          to: '/',
          disabled: false
        },
        {
          text: 'Executive Summary',
          key: 'Executive Summary',
          to: '/module/276/page/ReadMe.md',
          disabled: false
        },
        {
          text: 'Contextualisation Guide',
          key: 'Contextualisation Guide',
          to: '/module/276/page/abc.md',
          disabled: false
        },
        {
          text: 'Contextualisation Questions',
          key: 'Contextualisation Questions',
          to: '/module/276/page/bcd.md',
          disabled: true
        }
      ]
    };
  },
  computed: {
    showItems() {
      return this.showLongTitle
        ? this.longTitleItems.slice(0, this.selectedValue)
        : this.items.slice(0, this.selectedValue);
    },
    longTitleItems() {
      return this.items.map((item) => {
        return {
          ...item,
          text: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit.`
        };
      });
    }
  }
};
</script>
